import { FC } from 'react';
import '@styles/components/appFooter.less';

interface Props {
  showPhone?: boolean;
}

const AppFooter: FC<Props> = ({ showPhone = true }) => {
  return (
    <div className={'app-footer'}>
      {/* {showPhone && ( */}
      {/*   <div className={'phone'}> */}
      {/*     <img src={require('@images/common/phoneIcon.png').default} alt="" /> */}
      {/*     <a href="tel:400-650-5128">400-650-5128</a> */}
      {/*   </div> */}
      {/* )} */}

      <div className={'about'}>
        <div className={'wx-code'}>
          <div>
            <img src={require('@images/common/wxCode1.png').default} alt="" />
            <span>官方微信</span>
            <span>即时沟通</span>
          </div>
          <div>
            <img src={require('@images/common/wxCode2.png').default} alt="" />
            <span>扫描了解</span>
            <span>更多产品</span>
          </div>
        </div>

        <div className={'copyright'}>
          <p>Copyright © 1999-2022 北京跨世纪软件技术有限公司</p>
          <p>京ICP备15015286号</p>
        </div>
      </div>
    </div>
  );
};

export default AppFooter;
